import React from 'react';

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-bg">
        <div className="hero-pattern"></div>
        <div className="hero-gradient"></div>
      </div>
      <div className="hero-content">
        <div className="hero-badge">✨ 手工制作 · 匠心工艺</div>
        <h1 className="hero-title">
          <span className="hero-title-line">生命中的</span>
          <span className="hero-title-line accent">每一个甜蜜时刻</span>
        </h1>
        <p className="hero-subtitle">精选天然食材，法国传统工艺，为您呈现精致法式甜品</p>
        <div className="hero-actions">
          <a href="#cakes" className="btn btn-primary">探索系列</a>
          <a href="#about" className="btn btn-secondary">了解更多</a>
        </div>
      </div>
      <div className="hero-scroll">
        <span>向下滚动</span>
        <div className="scroll-line"></div>
      </div>
      <div className="hero-decorations">
        <div className="decoration-circle"></div>
        <div className="decoration-line"></div>
      </div>
    </section>
  );
}

export default Hero;
